import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import CategoryTabs from '../CategoryTabs'
import StandardSearch from '../StandardSearch'
interface Props {
  sx?: SxProps
  search: string | null
  setSearch: (search: string | null) => void
  category: string | null
  setCategory: (category: string | null) => void
}

const EntitiesListHero = React.memo((props: Props) => {
  const { sx, search, category, setSearch, setCategory } = props

  // success
  return (
    <Box
      sx={{
        ...sx
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          mb: 1
        }}
      >
        <CategoryTabs
          type="entity"
          category={category}
          setCategory={setCategory}
        />

        <StandardSearch search={search} setSearch={setSearch} />
      </Box>
    </Box>
  )
})

export default EntitiesListHero
